export default __webpack_public_path__ + "static/media/element_64.93d4fddd.webp";